import { Component, OnInit } from "@angular/core";
import { LocalStorageService } from "angular-2-local-storage";
import { LocalDataSource } from "ng2-smart-table";
import { environment } from "../../../../environments/environment";
import { AuthorizedApps } from "../../../enum/shared/authorized-apps.enum";
import { ProFunnelListModel } from "../../../model/builk/profunnel/profunnel-list.model";
import { SearchProFunnelModel } from "../../../model/builk/profunnel/search-profunnel.model";
import { ProFunnelService } from "../../../service/api/builk/profunnel.service";
import { PolicyService } from "../../../service/policy.service";
// import { ProvinceEntryComponent } from "../../shared/province-entry-component/province.entry.component";
// import { ProFunnelButtonComponent } from "./profunnel-button/profunnel-button.component";
// import { ProFunnelCommentComponent } from "./profunnel-comment/profunnel-comment.component";
// import { ProFunnelRefreshComponent } from "./profunnel-refresh/profunnel-refresh.component";
import { ProFunnelModel } from "../../../model/builk/profunnel/profunnel.model";
import { ProfunnelInfo } from "../../../model/builk/profunnel/profunnel-info.model";
import { AddressService } from "../../../service/api/builk/address.service";
import { formatDate } from "@angular/common";

@Component({
    selector: "bo-builk-profunnel",
    templateUrl: "./profunnel.component.html",
    styleUrls: ["./profunnel.component.scss"]
})

export class ProFunnelComponent implements OnInit {
    // localDataSource = new LocalDataSource();

    constructor(
        private readonly proFunnelService: ProFunnelService,
        private readonly policyService: PolicyService,
        private readonly localStorageService: LocalStorageService,
        private readonly addressService: AddressService
    ) { }

    // settings = {
    //     actions: {
    //         add: false,
    //         edit: false,
    //         delete: false
    //     },
    //     attr: {
    //         class: "table table-hover table-sm"
    //     },
    //     columns: {
    //         refresh: {
    //             title: "Refresh",
    //             type: "custom",
    //             width: "2%",
    //             filter: false,
    //             renderComponent: ProFunnelRefreshComponent,
    //             onComponentInitFunction: this.onUpdate.bind(this)
    //         },
    //         id: {
    //             title: "Id",
    //             type: "number",
    //             width: "2%"
    //         },
    //         companyName: {
    //             title: "Company",
    //             type: "string",
    //             width: "8%"
    //         },
    //         companyCode: {
    //             title: "URL",
    //             type: "html",
    //             width: "4%",
    //             valuePrepareFunction: (cell, row) => {
    //                 return `<a target="_blank" href="http://app.builk.com/${row.companyCode}">${row.companyCode}</a>`;
    //             }
    //         },
    //         companyType: {
    //             title: "Type",
    //             type: "string",
    //             width: "2%",
    //             valuePrepareFunction: (cell, row) => {
    //                 switch (row.companyType) {
    //                     case 1: return "General Contractor";
    //                     case 2: return "Heavy Construction Contractor";
    //                     case 3: return "M&E Contractor";
    //                     case 4: return "Building Contractor";
    //                     case 5: return "Specialty Contractor";
    //                     case 6: return "Interior/Decorate/Landscape Contractor";
    //                     case 7: return "Home Building Contractor";
    //                     case 8: return "Miscellaneous";
    //                     case 9: return "Highway/Road Construction Contractor";
    //                     case 10: return "Material Supplier/Reseller";
    //                     case 11: return "Material Manufacturer";
    //                     case 12: return "ผู้รับเหมาซ่อมแซมอาคาร";
    //                     case 13: return "Designer";
    //                     case 14: return "Consultant";
    //                     case 15: return "Building Contractor";
    //                     default: return "-";
    //                 }
    //             },
    //             filter: {
    //                 type: "list",
    //                 config: {
    //                     selectText: "Search",
    //                     list: [
    //                         { value: "1", title: "General Contractor" },
    //                         { value: "2", title: "Heavy Construction Contractor" },
    //                         { value: "3", title: "M&E Contractor" },
    //                         { value: "4", title: "Building Contractor" },
    //                         { value: "5", title: "Specialty Contractor" },
    //                         { value: "6", title: "Interior/Decorate/Landscape Contractor" },
    //                         { value: "7", title: "Home Building Contractor" },
    //                         { value: "8", title: "Miscellaneous" },
    //                         { value: "9", title: "Highway/Road Construction Contractor" },
    //                         { value: "10", title: "Material Supplier/Reseller" },
    //                         { value: "11", title: "Material Manufacturer" },
    //                         { value: "12", title: "ผู้รับเหมาซ่อมแซมอาคาร" },
    //                         { value: "13", title: "Designer" },
    //                         { value: "14", title: "Consultant" },
    //                         { value: "15", title: "Building Contractor" }
    //                     ]
    //                 }
    //             }
    //         },
    //         companyGrade: {
    //             title: "Grade",
    //             type: "string",
    //             width: "2%"
    //         },
    //         companyState: {
    //             title: "Province",
    //             type: "custom",
    //             width: "4%",
    //             renderComponent: ProvinceEntryComponent
    //         },
    //         contactName: {
    //             title: "Contact Name",
    //             type: "string",
    //             width: "8%"
    //         },
    //         contactEmail: {
    //             title: "Email",
    //             type: "string",
    //             width: "4%"
    //         },
    //         contactPhone: {
    //             title: "Phone",
    //             type: "string",
    //             width: "4%"
    //         },
    //         companyBadge: {
    //             title: "Badge",
    //             type: "custom",
    //             width: "4%",
    //             renderComponent: ProFunnelButtonComponent
    //         },
    //         comment: {
    //             title: "Comment",
    //             type: "custom",
    //             width: "8%",
    //             renderComponent: ProFunnelCommentComponent
    //         },
    //         totalDoc: {
    //             title: "Doc",
    //             type: "number",
    //             width: "2%"
    //         },
    //         totalCp: {
    //             title: "Cp",
    //             type: "number",
    //             width: "2%"
    //         },
    //         cpPageView: {
    //             title: "View",
    //             type: "number",
    //             width: "2%"
    //         }

    //     },
    //     pager: {
    //         display: true,
    //         perPage: 25
    //     }
    // };

    // Model
    getProFunnel: SearchProFunnelModel = new SearchProFunnelModel();
    proFunnelResult: ProFunnelListModel = new ProFunnelListModel();
    proFunnelList: Array<ProFunnelModel> = new Array<ProFunnelModel>();
    countryList = new Array<string>();
    profunnelInfo: ProfunnelInfo = new ProfunnelInfo();
    config: {country: string, lang: string} = {
      country: 'TH',
      lang: 'th'
    }
    periodDate: Array<Date> = [];

    // Pagination
    page: number = 1;
    limit: number = 25;
    countAll: number = 0;
    lastPage: number = 1;

    // Search
    searchCompanyId: string;
    searchCompanyName: string;
    searchCompanyState: string;
    searchCompanyType: number;
    searchCompanyCountry: string = 'TH';
    searchHiddenCompany: boolean;
    searchCompanyUrl: string;
    searchCompanyGrade: string;
    searchContactName: string;
    searchEmail: string;
    searchPhone: string;

    // boolean
    isCollapsed: boolean = true; //true is hide
    isInfoLoading: boolean = false;
    isCultureAccess: boolean = false;
    isAbleExport: boolean = true;
    isExporting: boolean = false;

    // Company Type List
    companyTypeList = [{
            id: 1,
            companyType: "General Contractor"
        }, {
            id: 2,
            companyType: "Heavy Construction Contractor"
        }, {
            id: 3,
            companyType: "M&E Contractor"
        }, {
            id: 4,
            companyType: "Building Contractor"
        }, {
            id: 5,
            companyType: "Specialty Contractor"
        }, {
            id: 6,
            companyType: "Interior/Decorate/Landscape Contractor"
        }, {
            id: 7,
            companyType: "Home Building Contractor"
        }, {
            id: 8,
            companyType: "Miscellaneous"
        }, {
            id: 9,
            companyType: "Highway/Road Construction Contractor"
        }, {
            id: 10,
            companyType: "Material Supplier/Reseller"
        }, {
            id: 11,
            companyType: "Material Manufacturer"
        }, {
            id: 12,
            companyType: "ผู้รับเหมาซ่อมแซมอาคาร"
        }, {
            id: 13,
            companyType: "Designer"
        }, {
            id: 14,
            companyType: "Consultant"
        }, {
            id: 15,
            companyType: "building contractor"
        }];

    countryOptions: Array<{value: any, label: string}> = []

    companyGradeOptions: Array<{value: any, label: string}> = [
      {value: 'PRO+', label: 'PRO+'},
      {value: 'PRO', label: 'PRO'},
      {value: 'A+', label: 'A+'},
      {value: 'A', label: 'A'},
      {value: 'B', label: 'B'},
      {value: 'C++', label: 'C++'},
      {value: 'C+', label: 'C+'},
      {value: 'CC', label: 'CC'},
      {value: 'CP', label: 'CP'},
      {value: 'D', label: 'D'}
    ]
    companyGradeModel: Array<{value: any, label: string}> = [];
    provinceOption: Array<{value: any, label: string}> = [];

    ngOnInit(): void {
        this.setProFunnelList();
        this.getCountry('th');
        this.getProvince('TH', 'th');
    }

    setProFunnelList(): void {
        this.getProFunnel.page = ((this.page - 1) * this.limit) + 1;
        this.getProFunnel.limit = this.limit;

        // Start of Get country list from user policy
        this.policyService.getUserPolicy(environment.firebaseConfig.policyCollection,
            "userEmail",
            this.localStorageService.get<string>("userEmail"))
            .subscribe(response => {
                if (response.length > 0) {
                    const authorizedApp = response[0].authorizedApps.find(f => f.appName === AuthorizedApps.Builk);
                    if (authorizedApp !== undefined) {
                        this.countryList = authorizedApp.country;
                        this.getProFunnel.culture = this.countryList.join(",");
                        this.initCountryFromCulture();
                    }
                } // End of Get country list from user policy
                this.getProFunnel.email = this.localStorageService.get<string>("userEmail");

                this.proFunnelService.getProFunnelBackOffice(this.getProFunnel)
                    .subscribe(
                        res => {
                            this.proFunnelResult = res;
                            this.proFunnelList = this.proFunnelResult.sourceData;
                            this.countAll = this.proFunnelResult.totalCount;
                            this.lastPage = Math.ceil((this.proFunnelResult.totalCount) / (this.limit));
                            // this.f.load(this.proFunnelResult.data);
                            // this.localDataSource.setPaging(this.getProFunnel.page, this.getProFunnel.limit, true);
                        }
                    );
                this.getProFunnelInfo();
            });
    }

    onUpdate(event: any): void {
        event.setProFunnelList.subscribe(
            s => {
                const temp = this.proFunnelResult.sourceData.find(f => f.id === s.id);
                // this.localDataSource.update(temp, s);
            }
        );
    }

    initFilter() {
      this.getProFunnel.searchCompanyId = this.searchCompanyId;
      this.getProFunnel.searchCompanyName = this.searchCompanyName;
      this.getProFunnel.searchCompanyState = this.searchCompanyState;
      if (this.searchCompanyType === null || this.searchCompanyType === undefined) {
          this.getProFunnel.searchCompanyType = undefined;
      } else {
          this.getProFunnel.searchCompanyType = this.searchCompanyType.toString();
      }
      this.getProFunnel.searchCompanyCountry = this.searchCompanyCountry;
      this.getProFunnel.searchHiddenCompany = this.searchHiddenCompany;
      this.getProFunnel.searchCompanyUrl = this.searchCompanyUrl;
      this.getProFunnel.searchCompanyGrade = this.companyGradeModel.map(val => val.value).join(',');
      this.getProFunnel.searchContactName = this.searchContactName;
      this.getProFunnel.searchEmail = this.searchEmail;
      this.getProFunnel.searchPhone = this.searchPhone;
    }

    searchProFunnel(): void {
        this.getProFunnelInfo();
        this.initFilter();
        this.page = 1;
        this.config = {
          lang: this.searchCompanyCountry.toLowerCase() != 'th' ? 'en' : 'th',
          country: this.searchCompanyCountry
        }
        this.setProFunnelList();
    }

    backPage(): void {
        if (this.page > 1) {
            this.page--;
            this.setProFunnelList();
        }
    }

    nextPage(): void {
        if (this.page < this.lastPage) {
            this.page++;
            this.setProFunnelList();
        }
    }

    goTofirstPage(): void {
        if (this.page > 1) {
            this.page = 1;
            this.setProFunnelList();
        }
    }

    goTolastPage(): void {
        if (this.page < this.lastPage) {
            this.page = this.lastPage;
            this.setProFunnelList();
        }
    }

    reload(event: boolean): void {
        this.setProFunnelList();
    }

    getProFunnelInfo() {
      this.isInfoLoading = true;
      let email = this.localStorageService.get<string>("userEmail");
      this.proFunnelService.getProFunnelInfo(this.searchCompanyCountry, this.getProFunnel.culture, email).subscribe(res => {
        this.profunnelInfo = res;
        this.isInfoLoading = false;
      })
    }

    getCountry(language: string): any {
      this.proFunnelService.getCompanyCountries().subscribe(ct => {
        this.addressService.getCountry(language).subscribe(res => {
          const countries = res.map(x => {
            return {
              label: x.text,
              value: x.id
            };
          });

          // Filter countries based on ct array
          const filteredCountries = countries.filter(country => ct.includes(country.value));

          // Sort the filtered countries array to prioritize "th" and "ph" first
          filteredCountries.sort((a, b) => {
            if (a.value === 'TH') {
              return -1; // "th" comes first
            } else if (b.value === 'TH') {
              return 1; // "th" comes first
            } else if (a.value === 'PH') {
              return -1; // "ph" comes second
            } else if (b.value === 'PH') {
              return 1; // "ph" comes second
            } else {
              return 0; // maintain the order for other countries
            }
          });

          filteredCountries.unshift(
            {
              value: '',
              label: 'All',
            }
          );

          this.countryOptions = filteredCountries.map(val => val);
        });
      });
    }

    getProvince(countryCode: string, language: string): any {
      this.addressService.getProvince(countryCode, language).subscribe(res => {
        this.provinceOption = res.map(x => {
          return {
            label: x.text,
            value: x.id
          };
        })
      });
    }

    onSortBy(congig: any) {
      this.getProFunnel.sortCol = congig.sortCol;
      this.getProFunnel.sortType = congig.sortType;
      this.searchProFunnel();
    }

    initCountryFromCulture() {
      if (this.countryList.length > 0) {
        if (this.countryList.some(val => val.toLocaleLowerCase() == 'th')) {
          this.isCultureAccess = true;
        } else {
          this.isCultureAccess = false;
          this.searchCompanyCountry = this.countryList.pop().toUpperCase();
          this.config = {
            lang: this.searchCompanyCountry.toLowerCase() != 'th' ? 'en' : 'th',
            country: this.searchCompanyCountry
          }
        }
      }
    }

    exportProFunnelBackOffice(): void {
      // if (this.periodDate.length == 0) {
      //   this.isAbleExport = false;
      //   return;
      // }
      this.initFilter();
      this.isAbleExport = true;
      this.isExporting = true;
      this.proFunnelService.exportProFunnelBackOffice(this.getProFunnel).subscribe((res) => {
        let url = window.URL.createObjectURL(res);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = "profunnel_report_" + formatDate(Date(), 'ddMMyyyy', 'en-US');
        a.click();
        window.URL.revokeObjectURL(url);
        this.isExporting = false;
        a.remove();
      }, (err) => {
        this.isExporting = false;
        alert("Error Message : " + err.message)
      }, () => {
        this.isExporting = false;
      });
    }

    resetDateRange(): void {
      this.periodDate = [];
      this.getProFunnel.startDate = undefined;
      this.getProFunnel.endDate = undefined;
    }

    onDateChange(): void {
      if (this.periodDate.length > 0) {
        this.isAbleExport = true;
        this.getProFunnel.startDate = this.periodDate[0];
        this.getProFunnel.endDate = this.periodDate[1];
      } else {
        this.getProFunnel.startDate = undefined;
        this.getProFunnel.endDate = undefined;
      }
    }
}
